function handleCreateJsonDesobstructionOsRequest(contract) {
    let typeOS = contract.typeOS.value == null ? contract.typeOS : contract.typeOS.value;
    console.log('typeos ', typeOS)
    let TYPE_OS = 1;


    return typeOS === TYPE_OS ? createJsonRedoMaintenance(contract) : createJsonInstallationClearance(contract);

}

function createJsonRedoMaintenance(contract) {
    let hourInitialPrimary = ""
    let hourFinishPrimary = ""
    let hourInitialSecundary = ""
    let hourFinishSecundary = ""

    if (contract.schedulingValue !== "Abertura imediata") {
        hourInitialPrimary = contract.hourInitialPrimary.value.split("-")[0];
        hourFinishPrimary = contract.hourInitialPrimary.value.split("-")[1];
        hourInitialSecundary = contract.hourInitialSecundary.value.split("-")[0];
        hourFinishSecundary = contract.hourInitialSecundary.value.split("-")[1];
    }


    let OsRequestContract = {
        typeOS: contract.typeOS.value,
        motivoValue: contract.motivoValue,
        schedulingValue: contract.schedulingValue,
        datePrimary: contract.datePrimary,
        hourInitialPrimary: hourInitialPrimary.trim(),
        hourFinishPrimary: hourFinishPrimary.trim(),

        dateSecundary: contract.dateSecundary,
        hourInitialSecundary: hourInitialSecundary.trim(),
        hourFinishSecundary: hourFinishSecundary.trim(),

        dateStartedAttendance: contract.dateStartedAttendance,

        statusOS: contract.statusOS,
        writeOffCode: contract.writeOffCode.value,
        observation: contract.observation,
        source: contract.source,
    }
    if (OsRequestContract.observation === null || OsRequestContract.observation === "") {
        delete OsRequestContract.observation;
    }

    return OsRequestContract;
}

function createJsonInstallationClearance(contract) {
    let hourInitialPrimary = "";
    let hourFinishPrimary = "";
    let hourInitialSecundary = "";
    let hourFinishSecundary = "";

    if (contract.schedulingValue != "Abertura imediata") {
        hourInitialPrimary = contract.hourInitialPrimary.value.split("-")[0];
        hourFinishPrimary = contract.hourInitialPrimary.value.split("-")[1];
        hourInitialSecundary = contract.hourInitialSecundary.value.split("-")[0];
        hourFinishSecundary = contract.hourInitialSecundary.value.split("-")[1];
    }

    let OsRequestContract = {
        typeOS: contract.typeOS.value,
        motivoValue: contract.motivoValue,
        schedulingValue: contract.schedulingValue,
        datePrimary: contract.datePrimary,
        hourInitialPrimary: hourInitialPrimary.trim(),
        hourFinishPrimary: hourFinishPrimary.trim(),

        dateStartedAttendance: contract.dateStartedAttendance,

        dateSecundary: contract.dateSecundary,
        hourInitialSecundary: hourInitialSecundary.trim(),
        hourFinishSecundary: hourFinishSecundary.trim(),

        observation: contract.observation,
        source: contract.source,
    }

    if (OsRequestContract.observation === null || OsRequestContract.observation === "") {
        delete OsRequestContract.observation;
    }
    return OsRequestContract
}


export default handleCreateJsonDesobstructionOsRequest;